import authService from '@/auth.service'
import Vue from 'vue';
import VueRouter from "vue-router";

import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

// Admin pages
import Overview from 'src/pages/Overview.vue'

import TableList from 'src/pages/TableList.vue'
import Typography from 'src/pages/Typography.vue'
import Icons from 'src/pages/Icons.vue'
import Maps from 'src/pages/Maps.vue'
import Notifications from 'src/pages/Notifications.vue'
import Upgrade from 'src/pages/Upgrade.vue'

//my pages
import LoginView from 'src/pages/Login/LoginView.vue'
import GrnCreate from 'src/pages/Grn/GrnCreate.vue'
import GrnIndex from 'src/pages/Grn/GrnIndex.vue' 
import GrnIndexreturn from 'src/pages/Grn/GrnIndexreturn.vue' 

import GrnView from 'src/pages/Grn/GrnView.vue'
import GrnUpdate from 'src/pages/Grn/GrnUpdate.vue'
import GrnCreatereturn from 'src/pages/Grn/GrnCreatereturn.vue'
import GrnUpdatedetail from 'src/pages/Grn/GrnUpdatedetail.vue'

import IssuetrackingIndex from 'src/pages/Issuetracking/IssuetrackingIndex.vue'
import IssuetrackingCreate from 'src/pages/Issuetracking/IssuetrackingCreate.vue'
import IssuetrackingCreatesplit from 'src/pages/Issuetracking/IssuetrackingCreatesplit.vue'
import IssuetrackingView from 'src/pages/Issuetracking/IssuetrackingView.vue'
import IssuetrackingJobview from 'src/pages/Issuetracking/IssuetrackingJobview.vue'
import IssuetrackingContractor from 'src/pages/Issuetracking/IssuetrackingContractor.vue'
import IssuetrackingContractorview from 'src/pages/Issuetracking/IssuetrackingContractorview.vue'
import SettingIndex from 'src/pages/Setting/SettingIndex.vue'
import SettingCreate from 'src/pages/Setting/SettingCreate.vue'
import SettingUpdate from 'src/pages/Setting/SettingUpdate.vue'
import SettingUpdateall from 'src/pages/Setting/SettingUpdateall.vue'
import SettingDefault from 'src/pages/Setting/SettingDefault.vue'
import ContractorsIndex from 'src/pages/Contractors/ContractorsIndex.vue'
import ContractorsCreate from 'src/pages/Contractors/ContractorsCreate.vue'
import ContractorsUpdate from 'src/pages/Contractors/ContractorsUpdate.vue'
import ContractorsView from 'src/pages/Contractors/ContractorsView.vue'


import UserIndex from 'src/pages/User/UserIndex.vue'
import UserPermission from 'src/pages/User/UserPermission.vue'
import UpdatePassword from 'src/pages/User/UpdatePassword.vue'
import UrlCreate from 'src/pages/User/UrlCreate.vue'
import UrlUpdate from 'src/pages/User/UrlUpdate.vue'
import UserCreate from 'src/pages/User/UserCreate.vue'
import CategoryIndex from 'src/pages/Category/CategoryIndex.vue'
import CategoryView from 'src/pages/Category/CategoryView.vue'
import CategoryCreate from 'src/pages/Category/CategoryCreate.vue'
import MessageIndex from 'src/pages/Message/MessageIndex.vue'
import UsertypeIndex from 'src/pages/User/UsertypeIndex.vue'
import DashbordIndex from 'src/pages/Dashbord/DashbordIndex.vue'
import UsermanualIndex from 'src/pages/Dashbord/UsermanualIndex.vue'
import UsermanualIndexmobile from 'src/pages/Dashbord/UsermanualIndexmobile.vue'
import UsertypePermission from 'src/pages/User/UsertypePermission.vue'

Vue.use(VueRouter);


 const routes  = [
 
  {
    path: '/',
    component: DashboardLayout,
    name: 'DashboardLayout',
    redirect: '/admin/overview'
  },
  {
    path: '/usermanual/index',
    name: 'UsermanualIndex',
    component: UsermanualIndex
  },
  {
    path: '/usermanual/indexmobile',
    name: 'UsermanualIndexmobile',
    component: UsermanualIndexmobile
  },
  {
    path: '/dashboard/index',
    name: 'DashbordIndex',
    component: DashbordIndex
  },
  {
    path: '/message/index',
    name: 'MessageIndex',
    component: MessageIndex
  },
  {
    path: '/category/create',
    name: 'CategoryCreate',
    component: CategoryCreate
  },
  {
    path: '/category/index',
    name: 'CategoryIndex',
    component: CategoryIndex
  },
  {
    path: '/category/view',
    name: 'CategoryView',
    component: CategoryView
  },
 
  {
    path: '/user/index',
    name: 'UserIndex',
    component: UserIndex
  },
  {
    path: '/user/permission',
    name: 'UserPermission',
    component: UserPermission
  },
  {
    path: '/user/updatepassword',
    name: 'UpdatePassword',
    component: UpdatePassword
  },
  {
    path: '/user/create',
    name: 'UserCreate',
    component: UserCreate
  },
  {
    path: '/usertype/permission',
    name: 'UsertypePermission',
    component: UsertypePermission
  },
  {
    path: '/usertype/index',
    name: 'UsertypeIndex',
    component: UsertypeIndex
  },
  {
    path: '/url/create',
    name: 'UrlCreate',
    component: UrlCreate
  },
  {
    path: '/url/update',
    name: 'UrlUpdate',
    component: UrlUpdate
  },


  {
    path: '/login',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/igrn/create',
    name: 'GrnCreate',
    component: GrnCreate
  },
  {
    path: '/igrn/index',
    name: 'GrnIndex',
    component: GrnIndex
  },
 
  {
    path: '/igrn/view',
    name: 'GrnView',
    component: GrnView
  },
  {
    path: '/igrn/update',
    name: 'GrnUpdate',
    component: GrnUpdate
  },
  {
    path: '/igrn/indexreturn',
    name: 'GrnIndexreturn',
    component: GrnIndexreturn
  },
  {
    path: '/igrn/updatedetail',
    name: 'GrnUpdatedetail',
    component: GrnUpdatedetail
  },
  {
    path: '/igrn/createreturn',
    name: 'GrnCreatereturn',
    component: GrnCreatereturn
  },
 
  
  {
    path: '/issuetracking/index',
    name: 'IssuetrackingIndex',
    component: IssuetrackingIndex
  },
  {
    path: '/issuetracking/create',
    name: 'IssuetrackingCreate',
    component: IssuetrackingCreate
  },
  {
    path: '/issuetracking/createsplit',
    name: 'IssuetrackingCreatesplit',
    component: IssuetrackingCreatesplit
  },
  {
    path: '/issuetracking/view',
    name: 'IssuetrackingView',
    component: IssuetrackingView
  },
  {
    path: '/issuetracking/jobview',
    name: 'IssuetrackingJobview',
    component: IssuetrackingJobview
  },
  {
    path: '/issuetracking/contractor',
    name: 'IssuetrackingContractor',
    component: IssuetrackingContractor
  },
  {
    path: '/issuetracking/contractorview',
    name: 'IssuetrackingContractorview',
    component: IssuetrackingContractorview
  },
  {
    path: '/setting/index',
    name: 'SettingIndex',
    component: SettingIndex
  },
  {
    path: '/setting/create',
    name: 'SettingCreate',
    component: SettingCreate
  },
  {
    path: '/setting/update',
    name: 'SettingUpdate',
    component: SettingUpdate
  },
  {
    path: '/setting/updateall',
    name: 'SettingUpdateall',
    component: SettingUpdateall
  },
  {
    path: '/setting/default',
    name: 'SettingDefault',
    component: SettingDefault
  },
  {
    path: '/contractors/index',
    name: 'ContractorsIndex',
    component: ContractorsIndex
  },
  {
    path: '/contractors/create',
    name: 'ContractorsCreate',
    component: ContractorsCreate
  },
  {
    path: '/contractors/update',
    name: 'ContractorsUpdate',
    component: ContractorsUpdate
  },
  {
    path: '/contractors/view',
    name: 'ContractorsView',
    component: ContractorsView
  },
 

  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
    
     
      
    ]
  },
  { path: '*', component: NotFound },
  
];








/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
